"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msalInstance = void 0;
const msal_browser_1 = require("@azure/msal-browser");
const authentication_1 = require("@/constants/authentication");
function buildMSALInstance() {
    return new msal_browser_1.PublicClientApplication(authentication_1.MSAL_INSTANCE_CONFIG);
}
exports.msalInstance = buildMSALInstance();
